// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ApiError, type PromptListe } from "../../api";
import { useGetPromptsByAufgabeInbound as useGetter } from "../hooks";
import { type QueryKey, useQuery, type UseQueryOptions } from "react-query";

export function usePromptsByAufgabeInboundQueryKey(
  aufgabeId: string
): QueryKey {
  return ["api", "v1", "aufgaben", aufgabeId, "inbound-prompts"];
}

export function usePromptsByAufgabeInbound(
  aufgabeId: string,
  options: Omit<
    UseQueryOptions<PromptListe, ApiError>,
    "queryKey" | "queryFn"
  > = {}
): PromptListe {
  const getter = useGetter();
  return useQuery(
    usePromptsByAufgabeInboundQueryKey(aufgabeId),
    () => getter(aufgabeId),
    options
  ).data!;
}
